import { render, staticRenderFns } from "./bball-text.vue?vue&type=template&id=382d477c&scoped=true"
import script from "./bball-text.vue?vue&type=script&lang=js"
export * from "./bball-text.vue?vue&type=script&lang=js"
import style0 from "./bball-text.vue?vue&type=style&index=0&id=382d477c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382d477c",
  null
  
)

export default component.exports